<div class="card">
  <div class="label">
    {{ label }} <span class="month">({{ currentMonth }})</span>
  </div>
  <div class="value">{{ value | number : "1.2-2" }} {{ units }}</div>
</div>
